<label *ngIf="selected" i18n>Всего выбрано записей: {{selected}}</label>
<label *ngIf="deletedClaims" i18n>Будет удалено записей: {{deletedClaims}}</label>
<div class="info" *ngIf="selected && selected > deletedClaims">
	<app-icon>error_outline</app-icon>
	<span i18n>Удаление оплаченных и/или частично оплаченных требование невозможно.</span>
</div>